export default {
  data() {
    return {
      inputType: 'checkbox',
      inputTypeDef: {}
    }
  },
  methods: {

  }
}
